import { useEffect, useRef, useState } from 'react';

const useAnimationEnd = (isMounted: boolean, delayTime: number) => {
  const [canShowDOM, setCanShowDOM] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    timeoutRef.current && clearTimeout(timeoutRef.current);
    if (isMounted) {
      setCanShowDOM(true);
    } else {
      // showing content till animation is completed
      timeoutRef.current = setTimeout(() => setCanShowDOM(isMounted), delayTime);
    }
    return () => {
      timeoutRef.current && clearTimeout(timeoutRef.current);
    };
  }, [isMounted, delayTime]);

  return canShowDOM;
};
export default useAnimationEnd;
